class ReportsAccessController {
  constructor(entityService, loadingService, growl) {
    "ngInject"

    this.entityService = entityService;
    this.loadingService = loadingService;
    this.growl = growl;

    this.selectedLocationId = null;
    this.selectedPref = null;
    this.locations = [];

    this.initializeLocations();
  }

  initializeLocations(){
    this.entityService.listAllLocations()
      .then(response => {
        const firstItem = {
          entityId: null,
          name: '---- Select Location ----'
        };

        this.locations = [firstItem, ...response.data.items];
      });
  }

  loadAccess() {
    if (!this.selectedLocationId) {
      return;
    }

    this.loadingService.showLoading('reportsAccess', 'Loading Reports Access ...');

    this.entityService.getEntityReportsAccess(this.selectedLocationId)
      .then(response => {      
        this.selectedReportsAccess = response.data;
      })
      .finally(() => {
        this.loadingService.hideLoading('reportsAccess');
      });    
  }

  toggleAccess(reportId) {
    if (!this.selectedLocationId) {
      return;
    }

    this.loadingService.showLoading('reportsAccess', 'Updating Reports Access ...');

    this.entityService.toggleEntityReportAccess(this.selectedLocationId, reportId)
      .then(response => {      
        this.growl.success('Report Access updated successfully', {ttl: 5000});
      })
      .finally(() => {
        this.loadingService.hideLoading('reportsAccess');
      });  
  }
}

export default ReportsAccessController;



// WEBPACK FOOTER //
// ./client/app/components/admin/reportsAccess/reportsAccess.controller.js